import { useLocation, useNavigate, } from "react-router-dom";
// material
import { Typography, Button, Box, Stack, Modal, IconButton, Grid, Card, CardHeader, CardContent, Tooltip, TextField, Tabs, Tab, FormControl, Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import AddIcon from "@mui/icons-material/Add";
import Page from "../../Page";
import LeaveDetailsPage from "../../../pages/SidebarMenus/LeaveMenu/LeaveDetailsPage";
import StickyHeader from "../../Common/StickyHeader";
import { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { startOfMonth, endOfMonth, format, parse } from 'date-fns';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import { useSnackbar } from 'notistack';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.5, 2)

}));
export default function LeaveAnalysis() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [absentListModal, setAbsentListModal] = useState(false);
    const [absentListData, setAbsentListData] = useState([]);
    const [upComingListData, setUpComingListData] = useState([]);
    const [holidayModal, setHolidayModal] = useState(false);
    const [holidayData, setHolidayData] = useState([]);
    const [year, setYear] = useState(new Date());
    const [tabValue, setTabValue] = useState(0);
    const [noOfDays, setNoOfDays] = useState("");
    const [pageSize, setPageSize] = useState(25);
    const [isLoading, setIsLoading] = useState();
    const [pageSize2, setPageSize2] = useState(25);

    const [month, setMonth] = useState('');
    const [selectedMonth, setSelectedMonth] = useState([]);


    const [monthYear, setMonthYear] = useState('');
    const [selectedMonthYear, setSelectedMonthYear] = useState([]);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        setNoOfDays("");
        setUpComingListData([]);
    };
    const handleNoOfDays = (event) => {
        setNoOfDays(event.target.value)
    };
    const handleMonth = (newValue) => setMonth(newValue?.MonthNo);
    const handleMonthYear = (newValue) => setMonthYear(newValue?.MonthNo);

    const handleAbsentListOpenModal = () => {
        setAbsentListModal(true);
        setIsLoading(true);

        const payload = {
            FromDate: "",
            ToDate: "",
            numOfDays: noOfDays
        };

        URLS.getAbsentList(payload)
            .then((response) => {
                console.log("absent>>>>>>>>>>>>", response.data);

                setAbsentListData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );

                enqueueSnackbar(
                    "Absent list fetched successfully.",
                    { variant: "success" }
                );
            })
            .catch((error) => {
                console.log("Error", error);

                setAbsentListData([]);

                enqueueSnackbar(
                    "Record not found.",
                    { variant: "error" }
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    console.log("data>>>>>>>>>>", absentListData)
    const handleAbsentListCloseModal = () => {
        setAbsentListModal(false);
        setNoOfDays("");
        setUpComingListData([]);
        setTabValue(0);
    };
    const handleHolidayOpenModal = () => {
        setHolidayModal(true);
        setIsLoading(true);
       
        const formattedDate = format(new Date(), "yyyy");

        const payload = {
            Year: formattedDate,
            Month: month || 0
        }
        URLS.getYearlyListOfHolidays(payload)
            .then((response) => {
                setHolidayData(
                    Array.isArray(response.data) ? response.data : []
                );
                enqueueSnackbar("Holiday list fetched successfully.", { variant: "success" });


            })
            .catch((error) => {
                enqueueSnackbar("Record not found.", {
                    variant: "error",
                });

                setHolidayData([]);
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const handleYear = (newValue) => {
        setYear(newValue);
    };
    const handleHolidayFilter = () => {
        setIsLoading(true);
        const formattedYear = format(year, "yyyy");
        const payload = {
            Year: formattedYear,
            Month: month || 0
        }

        URLS.getYearlyListOfHolidays(payload)
            .then((response) => {
                setHolidayData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );

                enqueueSnackbar(
                    "Holiday list fetched successfully",
                    {
                        variant: "success",
                    }
                );
            })
            .catch((error) => {
                enqueueSnackbar("Record not found.", {
                    variant: "error",
                });

                setHolidayData([]);
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    const handleHolidayReset = () => {
        setYear(new Date());
        setHolidayData([]);
        setMonth('');
        setMonthYear('');
    };
    const handleHolidayCloseModal = () => {
        setHolidayModal(false);
        handleHolidayReset();
    };
    const handleNavigate = () => {
        navigate('/dashboard/newissue');

    }
    const handleSearch = () => {
        setIsLoading(true);

        const payload = {
            FromDate: "",
            ToDate: "",
            numOfDays: noOfDays
        };

        URLS.getAbsentList(payload)
            .then((response) => {
                console.log("absent>>>>>>>>>>>>", response.data);

                setUpComingListData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );
                setIsLoading(false);

                enqueueSnackbar(
                    "Upcoming leave list fetched successfully.",
                    { variant: "success" }
                );
            })
            .catch((error) => {
                console.log("Error", error);

                setUpComingListData([]);
                setIsLoading(false);

                enqueueSnackbar(
                    "Record not found.",
                    { variant: "error" }
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    const holidayColumn = [
        { field: 'SrNo', headerName: 'Sr.No', flex: 0.2 },
        { field: 'Date', headerName: 'Date', flex: 1 },
        { field: 'DayOfWeek', headerName: 'Day', flex: 1 },
        { field: 'Remarks', headerName: 'Remark', flex: 2 },

    ];

    const upComingBaseColumn = [
        { field: 'Team', headerName: 'Department', flex: 0.5 },
        { field: 'Executive', headerName: 'Executive Name', flex: 1 },
        { field: 'Leave', headerName: 'No of Days', flex: 1 },
    ];

    const dateColumns =
        upComingListData.length > 0
            ? Object.keys(upComingListData[0])
                .filter(
                    key =>
                        !["TeamId", "Team", "ExecutiveId", "Executive", "Orderby", "Leave"].includes(key)
                )
                .map(date => ({
                    field: date,
                    headerName: date, // e.g. 05-May-2026
                    flex: 0.6,
                    renderCell: (params) => params.value || "-", // show '-' if null
                }))
            : [];

    const upComingColumn = [...upComingBaseColumn, ...dateColumns];

    useEffect(() => {
        URLS.getCurrentFinancialYear()
            .then((response) => {
                console.log("month>>>>>>>>>>>>", response.data);

                setMonthYear(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );
            })
            .catch((error) => {
                console.log("Error", error);

                enqueueSnackbar(
                    "Record not found.",
                    { variant: "error" }
                );
            })
        URLS.getCurrentFinancialYearWithMonths()
            .then((response) => {
                console.log("month>>>>>>>>>>>>", response.data);

                setSelectedMonth(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );
            })
            .catch((error) => {
                console.log("Error", error);

                enqueueSnackbar(
                    "Record not found.",
                    { variant: "error" }
                );
            })
    }, [])

    return (
        <Page title="Leave Management| tiketic" >
            <StickyHeader
                title="Leave Management"
                showButton={false}
                onButtonClick={handleNavigate}
                rightContent={
                    <Stack direction="row" spacing={1} alignItems="center" mt={'2px'}>
                        <Button
                            variant="outlined"
                            sx={{
                                color: "#0062FF",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #D0DBFF",
                                fontSize: '12px',
                                fontWeight: 500,
                                "& .MuiButton-startIcon": { mr: "2px" },
                                "&:hover": {
                                    backgroundColor: "#155DFC",
                                    color: "#FFFFFF",
                                    border: "1px solid #155DFC",

                                },
                                whiteSpace: "nowrap",
                                textTransform: "none",
                            }}
                            onClick={handleAbsentListOpenModal}
                        >
                            Absent List
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{
                                color: "#0062FF",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #D0DBFF",
                                fontSize: '12px',
                                fontWeight: 500,
                                "& .MuiButton-startIcon": { mr: "2px" },
                                "&:hover": {
                                    backgroundColor: "#155DFC",
                                    color: "#FFFFFF",
                                    border: "1px solid #155DFC",

                                },
                                whiteSpace: "nowrap",
                                textTransform: "none",
                            }}
                            onClick={handleHolidayOpenModal}
                        >
                            List Of Holidays
                        </Button>
                    </Stack>
                }
            />

            <Modal open={absentListModal} onClose={handleAbsentListCloseModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "75%",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        height: "75vh",
                        overflow: "auto",
                        borderRadius: "8px",
                    }}
                >
                    {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}

                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                            borderBottom: "1px solid #D1D5DB",
                        }}
                    >
                        <Typography variant="h6" fontWeight={600}>
                            Today’s Absent List
                        </Typography>

                        <IconButton onClick={handleAbsentListCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Content */}
                    <Box sx={{ px: 2 }}>
                        {/* Tabs */}
                        <Tabs value={tabValue} onChange={handleChange} sx={{ mb: 1 }}>
                            <Tab label="Today" />
                            <Tab label="Upcoming Days" />
                        </Tabs>

                        {/* TAB 1 → Today (Cards) */}
                        {tabValue === 0 && (
                            <Grid container spacing={3}>
                                {[...new Set(absentListData.map(item => item.Team))].map((team, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Card
                                            sx={{
                                                borderRadius: "12px",
                                                boxShadow: "none",
                                                border: "1px solid #E5E7EB",
                                                height: "100%",
                                            }}
                                        >
                                           
                                            <CardContent sx={{ pt: 2 }}>
                                                {[...new Map(
                                                    absentListData
                                                        .filter(item => item.Team === team)
                                                        .map(item => [item.ExecutiveId, item])
                                                ).values()].map((emp, i) => (
                                                    <Typography
                                                        key={i}
                                                        variant="body2"
                                                        sx={{ mb: 1, color: "#717883", fontWeight: 500 }}
                                                    >
                                                        {emp.Executive} - {emp.leaveType}
                                                    </Typography>
                                                ))}
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )}

                        {/* TAB 2 → Upcoming Days (DataGrid) */}
                        {tabValue === 1 && (
                            <>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>

                                    <TextField
                                        value={noOfDays}
                                        onChange={handleNoOfDays}
                                        placeholder="Enter No. of Days"
                                        fullwidth
                                        size="small"

                                    />
                                    <Tooltip title="Filter">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleSearch}
                                            sx={{ minWidth: 40, }}

                                        >
                                            <Icon icon="material-symbols:search" width="20" height="20" sx={{ mr: '3px' }} />
                                        </Button>
                                    </Tooltip>
                                </Stack>
                                <Box sx={{ height: "45vh", width: "100%" }}>
                                    <DataGrid
                                        rows={upComingListData}
                                        columns={upComingColumn}
                                        density="compact"
                                        getRowId={(row) => row.id || upComingListData.indexOf(row)}
                                        components={{ Toolbar: GridToolbar, }}
                                        pagination
                                        paginationMode="client"
                                        rowsPerPageOptions={[25, 50, 100]}
                                        pageSize={pageSize2}
                                        onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)} />

                                </Box>
                            </>
                        )}
                    </Box>
                </Box>
            </Modal>

            <Modal open={holidayModal} onClose={handleHolidayCloseModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "40%",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        height: "90vh",
                        overflow: "auto",
                        borderRadius: "8px",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                            borderBottom: "1px solid #D1D5DB",
                        }}
                    >
                        <Typography variant="h6" fontWeight={600}>
                            List Of Holidays
                        </Typography>

                        <IconButton onClick={handleHolidayCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Content */}
                    <Box sx={{ p: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>

                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    views={['year']}
                                    inputFormat="yyyy"
                                    value={year ? new Date(year) : null}
                                    onChange={(newValue) => { handleYear(newValue); }}
                                    renderInput={(params) => (
                                        <TextField
                                            size="small"
                                            {...params}
                                            sx={{ flex: 1 }}
                                            placeholder="Select Year"
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                            <FormControl size="small" sx={{ flex: 1 }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="month"
                                    value={
                                        selectedMonth.find(
                                            (option) => option.MonthNo === month
                                        ) || null
                                    }
                                    onChange={(_, newValue) => handleMonth(newValue)}
                                    options={selectedMonth}
                                    getOptionLabel={(option) => option.Month || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option.MonthNo === value.MonthNo
                                    }
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.MonthNo}>
                                            {option.Month}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Month"
                                        />
                                    )}
                                />
                            </FormControl>

                            <Tooltip title="Filter">
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleHolidayFilter}
                                    sx={{ minWidth: 40, flexShrink: 0 }}
                                >
                                    <Icon
                                        icon="material-symbols:search"
                                        width="20"
                                        height="20"
                                    />
                                </Button>
                            </Tooltip>

                            <Tooltip title="Reset">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleHolidayReset}
                                    sx={{ minWidth: 40, flexShrink: 0 }}
                                >
                                    <Icon
                                        icon="ic:twotone-restart-alt"
                                        width="20"
                                        height="20"
                                    />
                                </Button>
                            </Tooltip>
                        </Stack>

                        {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}

                        <Box sx={{ height: "65vh", width: "100%" }}>
                            <DataGrid
                                rows={holidayData}
                                columns={holidayColumn}
                                density="compact"
                                getRowId={(row) => row.id || holidayData.indexOf(row)}
                                rowsPerPageOptions={[25, 50, 100]}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                components={{ Toolbar: GridToolbar }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <ContentStyle>
                <LeaveDetailsPage />
            </ContentStyle>

        </Page>
    );
}

